/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Profeature61Inputs */

const zh_plan_profeature61 = /** @type {(inputs: Plan_Profeature61Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无文件大小限制`)
};

const en_plan_profeature61 = /** @type {(inputs: Plan_Profeature61Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited file upload size`)
};

const es_plan_profeature61 = /** @type {(inputs: Plan_Profeature61Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de archivo ilimitado`)
};

/**
* | output |
* | --- |
* | "Unlimited file upload size" |
*
* @param {Plan_Profeature61Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_profeature61 = /** @type {((inputs?: Plan_Profeature61Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Profeature61Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_profeature61(inputs)
	if (locale === "en") return en_plan_profeature61(inputs)
	return es_plan_profeature61(inputs)
});
export { plan_profeature61 as "plan_proFeature6" }